module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-consumable-item-shop-stock-count-list"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_consumable_item_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Consumable Item List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Shop Stock Consumable Item Count List')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Shop Stock Consumable Item Count List')))]), (_vm.consumableItemCounts.length) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label",
    staticStyle: {
      "padding-right": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('shopConsumableItem.label.consumable_item_name')))]), _c('div', {
    staticClass: "col-sm-10",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.consumable_item_name))])])]) : _vm._e(), (_vm.consumableItemCounts.length) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('shopConsumableItem.label.shop_name')))]), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('shopConsumableItem.label.just_stock_number')))]), _c('th', {
    staticClass: "col-sm-2"
  })])]), _c('tbody', _vm._l((_vm.consumableItemCounts), function(consumableItem, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(consumableItem.shop_name))]), _c('td', [_vm._v(_vm._s(consumableItem.just_stock_number) + " " + _vm._s(consumableItem.unit))]), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-info btn-sm margin-right",
      on: {
        "click": function($event) {
          _vm.goConsumableItemStockCountEdit(consumableItem.consumable_item_id, consumableItem.shop_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Edit')))])])])
  }))])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-683a687b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/master-consumable-item-shop-stock-count-list.pug
// module id = 839
// module chunks = 1